"use strict";
/*
 * Created on 23.05.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Radek Beran
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");

var PromotionPerformanceReportDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionPerformanceReportDataConverter, _DataObjectConverter_);

  function PromotionPerformanceReportDataConverter() {
    _classCallCheck(this, PromotionPerformanceReportDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportDataConverter).apply(this, arguments));
  }

  return PromotionPerformanceReportDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionPerformanceReportDataConverter = PromotionPerformanceReportDataConverter;